import script from "./PopoverTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./PopoverTitle.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__